<script setup lang="ts">
  defineProps({
    sections: Array,
  });
</script>
<template>
  <main>
    <SectionRenderer :sections="sections" class="homepage" />
  </main>
</template>
<style scoped lang="scss">
  main {
    max-width: 1920px;
    margin: 0 auto;

    .homepage {
      --sf-section-renderer-gap: 0;
    }
  }
</style>